import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {WebmateComponent} from '@webmate-web-core/navigation/webmate.component';
import {LoginComponent} from '@webmate-web-core/authentication/login.component';
import {ResetPasswordComponent} from '@webmate-web-core/authentication/reset-password.component';
import {ConfirmResetPasswordComponent} from '@webmate-web-core/authentication/confirm-reset.component';
import {AccountActivatingComponent} from '@webmate-web-core/authentication/account-activating.component';
import {AccountActivatedComponent} from '@webmate-web-core/authentication/account-activated.component';
import {LoginSSOComponent} from '@webmate-web-core/authentication/login-sso.component';
import {SSOHelperComponent} from '@webmate-web-core/authentication/sso-helper.component';
import {MobileAccessActivationComponent} from '@webmate-web-core/misc/mobileaccess-activation.component';
import {SignupComponent} from '@webmate-web-core/authentication/signup.component';
import {LoginContainerComponent} from '@webmate-web-core/authentication/login-container.component';
import {signUpGuard} from '@webmate-web-core/shared/guards/signup.guard';
import {authGuard} from '@webmate-web-core/shared/guards/auth.guard';
import {adminGuard, wmAdminGuard} from '@webmate-web-core/shared/guards/admin.guard';
import {ApplyChangeEmailTokenComponent} from "@webmate-web-core/authentication/apply-change-email-token.component";
import {ShowcaseComponent} from "../../showcase/showcase.component";
import {SwaggerUiComponent} from "@webmate-web-core/misc/swagger-ui.component";

const routes: Routes = [
    //     /** Authenticated Area */
    {
        path: '', component: WebmateComponent,
        children: [
            {
                path: '', redirectTo: '/projects', pathMatch: 'full'
            },
            {
                path: 'projects', canActivate: [authGuard],
                loadChildren: () => import('../webmate/projects/projects.module').then(m => m.ProjectsModule)
            },
            {
                path: 'administration', canActivate: [authGuard, adminGuard],
                loadChildren: () => import('../webmate/administration/administration.module').then(m => m.AdministrationModule)
            },
            {
                path: 'wmadmin', canActivate: [authGuard, wmAdminGuard],
                loadChildren: () => import('../webmate/webmate-admin/webmate-admin.module').then(m => m.WebmateAdminModule)
            },
            {
                path: 'user-profile', canActivate: [authGuard],
                loadChildren: () => import('../webmate/user-profile/user-profile.module').then(m => m.UserProfileModule)

            },
        ],
    },
    {
        path: 'workbench',
        canActivate: [authGuard],
        loadChildren: () => import('../workbench/workbench.module').then(m => m.WorkbenchModule)

    },
    {
        path: 'showcase',
        component: ShowcaseComponent
    },
    /** Not-Authenticated Area */
    {
        path: 'login',
        component: LoginContainerComponent,
        children: [
            {
                path: '',
                component: LoginComponent
            },
            {
                path: 'sso',
                component: LoginSSOComponent
            },
        ]
    },
    {
        path: 'signup',
        canActivate: [signUpGuard],
        component: SignupComponent
    },
    {path: 'login-sso', redirectTo: 'login/sso', pathMatch: 'full'},
    {path: 'ssohelper', component: SSOHelperComponent},
    {path: 'resetpassword', component: ResetPasswordComponent},
    {path: 'confirmreset', component: ConfirmResetPasswordComponent},
    {path: 'change-email', component: ApplyChangeEmailTokenComponent},
    {path: 'activation', component: AccountActivatingComponent},
    {path: 'activated', component: AccountActivatedComponent},
    {path: 'mobileaccess-activation', component: MobileAccessActivationComponent},
    {path: 'swagger', component: SwaggerUiComponent},
    {path: '**', redirectTo: '/projects'}
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {}),
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
